import React, { Component } from "react";
import SmartForm from "../../../components/smart-form/smart-form.js";
import formConfig from "./personnel-form-config.js";
import ArchivePersonnelDialog from "./archive-personnel-dialog.js";

import { getRoleLevelByID, getRoleIDByLevel } from "../../../../services/utils/personnel.js";

import "./personnel-form.css";

class PersonnelForm extends Component {
    constructor(props) {
        super(props);

        this.MODES = {
            ADD: 1,
            EDIT: 2
        }

        this.state = {
            show_archive_dialog: false,
            send_usage_email: false
        };
    }

    async onSubmit(formData) {
        let { add_personnel, edit_personnel, mode, roles } = this.props;

        formData.role = getRoleIDByLevel(parseInt(formData.role, 10), roles);

        if (mode === this.MODES.ADD) {
            await add_personnel(formData);
        }
        else if (mode === this.MODES.EDIT) {
            await edit_personnel(formData);
        }
    }

    showArchiveDialog() {
        this.setState({
            show_archive_dialog: true
        })
    }

    hideArchiveDialog() {
        this.setState({
            show_archive_dialog: false
        })
    }

    hideForm() {
        let { hide_func } = this.props;
        this.setState({ errors: [], show_archive_dialog: false });
        hide_func();
    }

    archiveDone(personnelID) {
        let { archive_done } = this.props;
        this.hideForm();
        archive_done(personnelID);
    }

    render() {
        let { mode, show, set, clear, roles, organizations, errors, edit_personnel_data, token } = this.props;
        let { show_archive_dialog } = this.state;

        let title = "Add Personnel";
        let isEdit = mode === this.MODES.EDIT ? true : false;
        if (isEdit) {
            title = "Edit Personnel";
        }

        if (set) {
            set.role = getRoleLevelByID(parseInt(set.role, 10), roles);
        }

        let completeConfig = formConfig;
        let inputConfigs = formConfig.inputs;
        completeConfig.inputs = [];
        for (let index in inputConfigs) {
            let currentInputconfig = inputConfigs[index];
            if (currentInputconfig.name === "organizations") {
                let orgsToAdd = [];
                for (let orgIndex in organizations) {
                    let currentOrg = organizations[orgIndex];

                    let orgToAdd = {
                        label: currentOrg.name,
                        value: currentOrg.id
                    };
                    orgsToAdd.push(orgToAdd);
                }
                currentInputconfig.options = orgsToAdd;
            }

            if (currentInputconfig.name === "role") {
                let rolesToAdd = [];
                for (let roleIndex in roles) {
                    let currentRole = roles[roleIndex];

                    let roleToAdd = {
                        text: currentRole.name,
                        value: currentRole.level
                    };
                    rolesToAdd.push(roleToAdd);
                }
                currentInputconfig.options = rolesToAdd;
            }

            if (mode === this.MODES.EDIT) {
                if (currentInputconfig.name === "password") {
                    currentInputconfig.label = "New Password (fill in to change)"
                    currentInputconfig.required = false;
                }
            }
            else if (mode === this.MODES.ADD) {
                if (currentInputconfig.name === "password") {
                    currentInputconfig.label = "Password"
                    currentInputconfig.required = true;
                }
            }
            completeConfig.inputs.push(currentInputconfig);
        }

        let personnelFormDialogClass = "personnel_form_dialog";
        if (show_archive_dialog) {
            personnelFormDialogClass += " hidden";
        }

        if (show) {
            return (
                <div className='personnel_form_container'>
                    <div onClick={this.hideForm.bind(this)} className='personnel_form_modal'></div>
                    <div className={personnelFormDialogClass}>
                        <div onClick={this.hideForm.bind(this)} className='personnel_form_dialog_hide'><i className='fa fa-times'></i></div>
                        <div className='personnel_form'>
                            <div className='personnel_form_title'>{title}</div>
                            <SmartForm config={completeConfig} set={set} clear={clear} on_submit={this.onSubmit.bind(this)} submission_errors={errors} />
                        </div>
                        {isEdit && <div className='personnel_form_archive' onClick={this.showArchiveDialog.bind(this)}>Archive</div>}

                    </div>
                    {show_archive_dialog && <ArchivePersonnelDialog personnel_data={edit_personnel_data} token={token} cancel_archive={this.hideArchiveDialog.bind(this)} archive_done={this.archiveDone.bind(this)} />}
                </div>
            );
        }
        else {
            return "";
        }
    }
}

export default PersonnelForm;



// WEBPACK FOOTER //
// ./src/components/containers/manager-dashboard/manage-personnel/personnel-form.js